import { DrawerContainer, DrawerContent } from '../../components/ui/drawer.tsx';
import { Header } from '../../components/ui/header.tsx';
import { useLocale } from '../../lib/hooks/use-locale.ts';

export type Drawer404Props = {
    onBack?: () => void;
    onClose?: () => void;
};

export function Drawer404({ onBack, onClose }: Drawer404Props) {
    const { t } = useLocale();

    return (
        <DrawerContainer>
            <div className="flex flex-col gap-3 bg-white px-5 pt-3 border-b border-neutral-200 h-full">
                <Header className="border-b-0" onBack={onBack} onClose={onClose} />
                <DrawerContent>
                    <div className="mx-auto flex w-full max-w-7xl flex-auto flex-col justify-center px-6 py-24 sm:py-64 lg:px-8">
                        <p className="text-lg font-semibold leading-8 text-indigo-600">404</p>
                        <h1 className="mt-4 text-3xl font-bold tracking-tight text-neutral-900 sm:text-5xl">
                            {t('not_found_drawer__title')}
                        </h1>
                        <p className="mt-6 text-lg leading-7 text-neutral-600">
                            {t('not_found_drawer__description')}
                        </p>
                    </div>
                </DrawerContent>
            </div>
        </DrawerContainer>
    );
}
